<template>
  <div>
    <vs-tabs class="unique_cstm_tab">
      <vs-tab label="Notification" v-if="checkViewPermissionForNotification()">
        <vs-card id="ag-grid-demo">
          <Table v-if="checkViewPermissionForNotification()" />
        </vs-card>
      </vs-tab>
      <vs-tab label="Notification Template">
        <NotificationTemplate :deletePermission="checkDeletePermissionForNotificationTem()" :createPermission="checkCreatePermission()" :editPermission="checkEditPermissionForNotificationTem()" :viewPermission="checkViewPermissionForNotificationTem()"></NotificationTemplate>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import Table from './table'
import NotificationTemplate from '../notification-template/notificationTemplate.vue'
// import cellRender from './icons'

export default {
  name: 'notification',
  components: {
    // deleteCell,
    Table,
    NotificationTemplate
  },
  mixins: [PermissionMiddleware],
  created () {
    this.checkPermissionForStaff()
  },
  data () {
    return {
      
    }
  },
  methods: {
    checkPermissionForStaff () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Communication')
      }
    }
  }
}
</script>

<style>
  .unread {
    background-color: #fff5ec;
    font-weight: 500;
  }
  .read {
    background-color: transparent !important;
    font-weight: 500;
  }
</style>